import {reportUrls, sendImpressions, bannerClick,RewardJsInstall,VideoBridgeClick} from '@api/index'

import App from "../class/App";

import {
    device,
    getMousePosition,
    getParams2Native,
    replaceAppFlyerHost,
    getAppFlyerRoute,
    sendAdtracking,
    checkAndroidSDKVersion
} from './util'

import {
    setClickUrl,
    setNoticeUrl,
} from './tool'


/**
 * 安卓上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
 * 安卓 js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
 * @param prams [{type: '', url: only_impression_url}]
 * @param prams [{type: imp_ua, url: impression_url}]
 */
function _reportUrlsAndroid(prams, index) {
    if (index >= prams.length) {
        console.log("index没有大于length");
        return
    }
    const _this = this;
    console.log("开始reporturl", prams, index)
    return reportURLs([prams[index]]).then(res => {
        console.log("再次上报下一个")
        _reportUrlsAndroid(prams, ++index)
    }).catch(err => {
        console.log(err)
    })
}

/**
 * 上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
 * @param prams [{type: '', url: only_impression_url}]
 * @param prams [{type: imp_ua, url: impression_url}]
 */
export function reportURLs(params) {
    console.log("IOS-reporturl", params)
    return reportUrls(params)
}

/**
 * pv统计 无论几个offer都只上报一次，only_impression_url
 */
export function reportPV(URL) {
    let arr = []
    if (Array.isArray(URL)) {
        URL.forEach(url => {
            arr.push({url})
        })
    } else {
        arr.push({url: URL})
    }
    // 安卓 会超10240，所以对安卓进行拆分，多次上报
    if (device().isAndroid) {
        _reportUrlsAndroid(arr, 0)
    } else {
        reportURLs(arr)
    }
}

/**
 * 展示统计 （ 只有offer展示才上报 ）,向sdk传展示的offer的 cid
 * prams ['cid1','cid2']
 *
 */
export function reportImpressions(impressions) {
    return sendImpressions(impressions)
}

function _iosEnCodeURL(url) {
    /*if(device().isiOS){
        return encodeURIComponent(url)
    }*/
    return url
}

/**
 * 上报Offer impression_url,ad_tracking.impression, 一个offer展示一次上报一次，每个offer只上报一次
 */
export function reportOfferImpression(campaignList) {
    let arr = [];
    campaignList.forEach((offer) => {
        arr.push({
            type: offer['imp_ua'],
            url: _iosEnCodeURL(offer['impression_url'])
        })
        const adTrackingImpression = offer.ad_tracking ? offer.ad_tracking.impression : "";
        if (adTrackingImpression && Array.isArray(adTrackingImpression) && adTrackingImpression.length > 0) {
            adTrackingImpression.forEach((item) => {
                arr.push({
                    url: _iosEnCodeURL(item)
                })
            })
        } else if (adTrackingImpression && typeof adTrackingImpression) {
            arr.push({
                url: _iosEnCodeURL(adTrackingImpression)
            })
        }
    })
    //安卓js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
    if (device().isAndroid) {
        console.log("isAndroid,准备上报安卓impression", arr)
        _reportUrlsAndroid(arr, 0)
    } else {
        console.log("IOS,准备上报IOSimpression", arr)
        reportURLs(arr)
    }
}
/**
 * 自动storekit坐标拼接
 * @param {object} defaultCampaign
 * @param {boolean} isFromMoreOffer 是否为多offer
 */
export function setStorekitStatus(defaultCampaign,isFromMoreOffer) {
    // isFromMoreOffer 用来标识是否当前点击是否来自底部推荐位
    // 由于 SDK 暂时只支持主 offer 的 storekit 预加载, 所以点击底部推荐位时, needStorekit 应始终为 false,
    // 避免点击底部推荐位加载 storekit 失败, 又不跳转外部 App Store 的问题
    // 当needStorekit = 1的时候，如果ios判断不能出storekit,则什么也不做，否则跳。
    defaultCampaign.needStorekit = !isFromMoreOffer ? 1 : 0;
    return defaultCampaign
}
/**
 *@点击跳转
 *@param {Object} opts
    *@param {Boolean} autoClick ,是否为自动点击
    *@param {String} template:rv 播放模版，ec endcard模版，banner banner模版
    *@param {Boolean} ctabanner:true
    *@param {Object} campaign
 *@author WangPing
 *@date 2020-06-01
 */
export function onScreenClick(event, opts) {
    console.log("点击event",event)
    console.log("点击opts",opts)
    let defaultCampaign = Object.assign({}, this.campaign || opts.campaign || {})
    // 用于避免安卓参数过长被截断的问题
    if (device().isAndroid) {
        defaultCampaign = getParams2Native(defaultCampaign);
    }
    // click_url 替换
    let clickPosition = getMousePosition(event);
    let _data = App.initData;
    const _scale = _data.device && _data.device.scale || window.devicePixelRatio||2;
    console.log("this.windowStartPoint",this.windowStartPoint)
    console.log("clickPosition计算之前",clickPosition)
    console.log("_scale",_scale)
    console.log("window.devicePixelRatio",window.devicePixelRatio)
    console.log("_data.device.scale",_data.device.scale)
    let startX = Number(this.windowStartPoint.startX) || 0;
    let startY = Number(this.windowStartPoint.startY) || 0;
    if (device().isAndroid) { // 安卓startX,startY返回dp需要乘scale，返回px则不乘scale，这里返回px,本身点击坐标需要乘scale
        clickPosition.x = +clickPosition.x * _scale + startX;
        clickPosition.y = +clickPosition.y * _scale + startY;
    } else {
        clickPosition.x = (+clickPosition.x + startX) * _scale;
        clickPosition.y = (+clickPosition.y + startY) * _scale;
    }
    console.log("重新计算后的clickPosition",clickPosition)
    clickPosition.scale = _scale
    //  如果是自动storekit，重置坐标
    if (opts.autoClick) {
        clickPosition.x = -999;
        clickPosition.y = -999;
        defaultCampaign = setStorekitStatus(defaultCampaign, isFromMoreOffer);
    }
    // 设置clickurl
    defaultCampaign = setClickUrl(defaultCampaign, clickPosition, _data);
    // 设置noticeurl坐标宏替换
    defaultCampaign = setNoticeUrl(defaultCampaign, clickPosition, this.windowStartPoint, false,opts.ctabanner)
    sendAdtracking(defaultCampaign.click_url)
    // appflyer替换
    replaceAppFlyerHost(defaultCampaign)
    // 安卓一定要在组装defaultCampaign之前格式化
    if (device().isAndroid) {
        defaultCampaign = getParams2Native(defaultCampaign);
    }
    // 如果是banner模板需要组装defaultCampaign

    if(opts.template === 'rv' || opts.template === 'banner'){
        defaultCampaign = {
            type: 1,
            pt: defaultCampaign
        }
    }
    // ios针对组装后的defaultCampaign 进行encode ,callNative里已经进行了转换，这里不用转换
    if (opts.template === 'rv') {
        VideoBridgeClick(defaultCampaign).then(res => {
        }).catch(err => {
            console.error(err)
        })
    } else if (opts.template === 'ec') {
        RewardJsInstall(defaultCampaign).then(res => {
        }).catch(err => {
            console.error(err)
        })
    } else {
        bannerClick(defaultCampaign).then(res => {
        }).catch(err => {
            console.error(err)
        })
    }
}